<script lang="ts">
  import Calendar from '$icons/CalendarIcon.svelte';
  import { createEventDispatcher } from 'svelte';
    import GlobalTextInput from './GlobalTextInput.svelte';
    import SimpleCaption from './SimpleCaption.svelte';

  export let value;
  export let label = '';
  export let caption = '';
  export let placeholder = 'Enter here';
  export let danger: boolean = false;
  export let dangerMessage: string = '';

  const dispatch = createEventDispatcher();

  $: {
    value, label;
    dispatch('change', { value, label });
  }

  function handleSubmit() {
    dispatch('change', value);
  }
</script>

<div class="flex flex-col items-start gap-2 w-full">
  <label class="text-garden-grey-600 font-medium text-sm" for="">
    {#if label}{label}{:else}&nbsp;{/if}
  </label>
  <div class="flex flex-row gap-0 items-center min-h-[54px]">
    <div
      role="button"
      tabindex="0"
      class="min-w-[50px] border border-r-0 rounded-r-none border-garden-grey-300 rounded-14 p-4 text-garden-grey-500 flex justify-center items-center cursor-pointer"
      on:keydown
      on:click={() => {
        dispatch('icon-click');
      }}
    >
      <slot>
        <Calendar />
      </slot>
    </div>

    <GlobalTextInput
      unround="l"
      {danger}
      {placeholder}
      hideCaption
      bind:value
      on:blur
      on:focus
      on:submit={handleSubmit} />
  </div>
  <SimpleCaption {danger} {dangerMessage} {caption} />
</div>
